module.exports = __webpack_public_path__ + "img/blr-logo-2022.8b5f42a5.png";